import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { StickyFooter } from 'foundations-components/transitional/components/StickyFooter';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { anyRequestsPending } from '../utils/requestStatusChecks';
import usageTracker from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SettingsStickySaveFooter({
  description,
  shouldRender,
  onCancel,
  onSave,
  saveDisabled,
  saveLoading,
  saveFailed,
  saveRequestStatus,
  disabledTooltip,
  disabledTooltipProps
}) {
  const savingInProgress = saveLoading || saveRequestStatus && anyRequestsPending(saveRequestStatus);
  function handleSave() {
    usageTracker.track('sulSettingsSave');
    onSave();
  }
  function handleCancel() {
    usageTracker.track('sulSettingsCancel');
    onCancel();
  }
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/_jsx(StickyFooter, {
    "data-test-id": "save-sticky-footer",
    children: /*#__PURE__*/_jsx(View, {
      paddingBlock: "500",
      paddingInline: "1000",
      backgroundColor: "fill-surface-raised",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsxs(ButtonWrapper, {
          children: [/*#__PURE__*/_jsx(Tooltip, Object.assign({
            disabled: !saveDisabled || !disabledTooltip,
            title: disabledTooltip
          }, disabledTooltipProps, {
            children: /*#__PURE__*/_jsx(LoadingButton, {
              use: "primary",
              disabled: saveDisabled || savingInProgress,
              loading: savingInProgress,
              failed: saveFailed,
              onClick: handleSave,
              "data-test-id": "save-footer-confirm-btn",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "settingsuilib.save"
              })
            })
          })), /*#__PURE__*/_jsx(Button, {
            use: "secondary",
            disabled: savingInProgress,
            onClick: handleCancel,
            "data-test-id": "save-footer-cancel-btn",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "settingsuilib.cancel"
            })
          })]
        }), /*#__PURE__*/_jsx(Text, {
          paddingInline: "600",
          "data-test-id": "save-footer-description",
          children: description
        })]
      })
    })
  });
}
SettingsStickySaveFooter.propTypes = {
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  shouldRender: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saveDisabled: PropTypes.bool,
  saveLoading: PropTypes.bool,
  saveFailed: PropTypes.bool,
  saveRequestStatus: PropTypes.string,
  disabledTooltip: PropTypes.node,
  disabledTooltipProps: PropTypes.object
};
export default SettingsStickySaveFooter;